import { h } from 'preact'
import { connectWithTranslations } from '../../../common/helpers/translationsHelpers'
import Countdown from '../../../common/components/Countdown'
import FormattedDate from '../../../common/components/FormattedDate'
import IconSpinnerSolid from '../../../common/components/icons/IconSpinnerSolid'
import { TIME_FORMAT_OPTIONS } from '../../constants'

const EventTime = ({ date, hasActual, onEventHappened, settings: { timezoneOffset},timeFormat,translate }) => (
    <Countdown
        date={date}
        shouldFinish={hasActual}
        timezoneOffset={timezoneOffset}
        updateIntervalSeconds={60}
        spinnerDurationSeconds={60}
        countdownDurationMinutes={59}
        renderSpinner={() => <span class="fxs_centered"><IconSpinnerSolid /></span>}
        renderCountdown={remainingTime => remainingTime && <span>{`${remainingTime.minutes}${translate('MinuteAbbreviation')}`}</span>}
        renderDateTime={date => <FormattedDate date={date} format = {timeFormat === TIME_FORMAT_OPTIONS.TwelveHours ? 'shortTime' : 'HH:MM'} />}
        renderFinished={date => <FormattedDate date={date} format = {timeFormat === TIME_FORMAT_OPTIONS.TwelveHours ? 'shortTime' : 'HH:MM'} />}
        onCountdownFinished={onEventHappened}
    />
)

export default connectWithTranslations('settings,timeFormat')(EventTime)
